import { useCallback } from "react";
import { useLocation } from "wouter";
import { useOptionalExpansion } from "@/contexts/expansion-context";
import { setFromSearchIntent } from "./focus-intent";

/**
 * Opens a project exactly like clicking a hit in the quick-search palette
 * (⌘K): everything except years collapses, the tree navigates to the
 * project, expands it and scrolls it into view.
 *
 * Shared by the palette and by other "jump to project" entry points such as
 * project timing rows in the Scheduled list. The `navigate-to-project`
 * event is what the tree listens for; `/?projectId=` is the cross-route
 * safety net when the tree is not mounted yet.
 */
export function useOpenProjectLikeQuickSearch() {
  const [, navigate] = useLocation();
  const expansion = useOptionalExpansion();
  const collapseAllExceptYears = expansion?.collapseAllExceptYears;
  return useCallback((projectId: string) => {
    setFromSearchIntent();
    collapseAllExceptYears?.();
    navigate(`/?projectId=${encodeURIComponent(projectId)}`);
    window.dispatchEvent(new CustomEvent("navigate-to-project", { detail: { projectId } }));
  }, [collapseAllExceptYears, navigate]);
}
